import { IssuePage } from './features/issue/IssuePage';
import { ChooseDocumentDetailsPage } from '@tap/doc-ui';
import { DocumentCode } from '@tap/data-providers';

export const DetailsPageRoutes = () => {
    return <ChooseDocumentDetailsPage pages={{
        [DocumentCode.QC]: IssuePage,
        [DocumentCode.UGM]: IssuePage,
        [DocumentCode.TOOL]: IssuePage,
        [DocumentCode.WIP]: IssuePage,
        [DocumentCode.TECH]: IssuePage,
    }} />
}
